import { render, staticRenderFns } from "./_admin-portal-users.vue?vue&type=template&id=9a5c694e"
import script from "./_admin-portal-users.vue?vue&type=script&lang=js"
export * from "./_admin-portal-users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports